import React from 'react';
import { DrawerToggleButton, NotificationContent, NotificationDrawer } from './notification.styles';

/**
 * Notifications page layout: list panel on the left, selected notification on the right.
 * On mobile the list panel becomes a drawer opened by its toggle button.
 * @param {React.ReactNode} sidebar Content of the list panel (tabs, search, list)
 * @param {boolean} isDrawerOpen Whether the mobile drawer is open
 * @param {Function} onToggleDrawer Called when the drawer's toggle button is clicked
 */
export default function NotificationLayout({ sidebar, isDrawerOpen, onToggleDrawer, children }) {
    return (
        <div>
            <NotificationDrawer $isOpen={isDrawerOpen}>
                <DrawerToggleButton
                    type="button"
                    $isOpen={isDrawerOpen}
                    aria-label={isDrawerOpen ? 'Close notifications list' : 'Open notifications list'}
                    onClick={onToggleDrawer}
                >
                    <i className={isDrawerOpen ? 'fal fa-times' : 'fal fa-bars'}></i>
                </DrawerToggleButton>
                {sidebar}
            </NotificationDrawer>
            <NotificationContent>{children}</NotificationContent>
        </div>
    );
}
